import { Box, CircularProgress } from '@mui/material'
import { useProfileRole } from '../hooks/useProfileRole'
import { AthleteProfileWizard } from './AthleteProfileWizard'
import { RecruiterProfileWizard } from './RecruiterProfileWizard'
import { EmptyStatePanel } from '../components/StatePanel'

/** The 3-step onboarding wizard, role-switched. Used only by `/onboarding`. */
export const ProfileWizardPage = () => {
  const { isLoading, isStudent, isRecruiter } = useProfileRole()

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" py={8}>
        <CircularProgress />
      </Box>
    )
  }

  if (isStudent) return <AthleteProfileWizard />
  if (isRecruiter) return <RecruiterProfileWizard />

  return (
    <EmptyStatePanel
      title="Profile unavailable"
      description="We couldn't determine your account type. Try refreshing, or contact support if this continues."
    />
  )
}
